const baseApi = '/api/v1/admin/users/permission';

async function getGroups({ condition }) {
  try {
    const res = await window.window.axios.get(baseApi + `/group`, { params: condition });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getGroup(id) {
  try {
    const res = await window.window.axios.get(baseApi + `/group/${id}`);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function addGroup(data) {
  try {
    const res = await window.window.axios.post(baseApi + '/group', data);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function editGroup(data) {
  try {
    const res = await window.window.axios.put(baseApi + '/group', data);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function deleteGroup(id) {
  try {
    const res = await window.window.axios.delete(baseApi + `/group/${id}`);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getRules({ condition }) {
  try {
    const res = await window.window.axios.get(baseApi + `/rule`, { params: condition });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getRule(id) {
  try {
    const res = await window.window.axios.get(baseApi + `/rule/${id}`);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function addRule(data) {
  try {
    const res = await window.window.axios.post(baseApi + '/rule', data);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function editRule(data) {
  try {
    const res = await window.window.axios.put(baseApi + '/rule', data);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function deleteRule(id) {
  try {
    const res = await window.window.axios.delete(baseApi + `/rule/${id}`);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = {
  getGroups,
  getGroup,
  addGroup,
  editGroup,
  deleteGroup,
  getRules,
  getRule,
  addRule,
  editRule,
  deleteRule,
};
